import { FEE_MODE } from 'Data/constants.js'

export function getView(fee_mode, fee_eligible) {
  // only platform fee allows charging ACH payments (surcharge is credit cards only)
  return fee_mode === FEE_MODE.PLATFORM_FEE && fee_eligible
}
